import { MdKeyboardBackspace } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { PrivatePolicyData } from "../data/profile/privatePolicy";

export default function PrivatePolicySection()
{
    const navigate=useNavigate();
    return(
        <div className="bg-white py-5 px-4 md:px-8 xl:px-10 xl:py-10 text-[#333]">
            <div className="flex flex-row space-x-2 items-center justify-start mb-5" onClick={()=>navigate(-1)}>
                    <MdKeyboardBackspace className="text-lg md:text-xl xl:text-2xl" />
                    <p className="text-lg md:text-xl xl:text-2xl font-medium text-center pb-2">Return Policy</p>
            </div>
              
            {PrivatePolicyData.sections.map((section, idx) => (
            <div key={idx} className="mb-6">
                <h2 className="text-sm md:text-base xl:text-lg font-semibold text-[#A63F40] mb-2">{section.heading}</h2>
                {section.content.map((para, index) => {
                if (Array.isArray(para)) {
                    return (
                        <ul className="list-disc list-inside ml-4 space-y-1  text-xs md:text-sm xl:text-base" key={index}>
                            {para.map((item, i) => (
                            <li key={i}>{item}</li>
                            ))}
                        </ul>
                    );
                } else {
                    return <p className="mb-2  text-xs md:text-sm xl:text-base space-y-1" key={index}>{para}</p>;
                }
            })}
            </div>
))}

            </div>
    );
}